import { render, staticRenderFns } from "./InsightProject.vue?vue&type=template&id=d0c3ac32"
import script from "./InsightProject.vue?vue&type=script&lang=js"
export * from "./InsightProject.vue?vue&type=script&lang=js"
import style0 from "./InsightProject.vue?vue&type=style&index=0&id=d0c3ac32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports